import { render } from "./CreditCardCreatorMercadoPago.vue?vue&type=template&id=45cb2d16&ts=true"
import script from "./CreditCardCreatorMercadoPago.vue?vue&type=script&lang=ts"
export * from "./CreditCardCreatorMercadoPago.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./CreditCardCreatorMercadoPago.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__